import type {
  AddFieldNameScope,
  AddFieldPlacementTarget
} from '@cli-types/core-engine/add-field.js'
import type { FormField } from '@cli-types/core-engine/schema.js'
import { ensureFormChildFields } from './ensure-form-child-fields.js'

export function collectFormNestedTargets(
  fields: FormField[],
  pathPrefix: string,
  scope: AddFieldNameScope,
  targets: AddFieldPlacementTarget[]
): void {
  for (const field of fields) {
    const fieldPath = `${pathPrefix}.${field.name || field.type}`
    if (field.type === 'group' || field.type === 'list') {
      const childScope: AddFieldNameScope = field.type === 'list' ? 'list-item' : scope
      targets.push({
        id: `${fieldPath}.fields`,
        label: `${fieldPath}.fields`,
        scope: childScope,
        getFields: () => ensureFormChildFields(field)
      })
      collectFormNestedTargets(field.fields ?? [], fieldPath, childScope, targets)
    }
  }
}
